import { logger } from "@platform/browser-logger";

import {
  RfpCarrierResponse,
  RfpCarriersResponse,
} from "../hooks/useRfpCarriers";
import {
  CarrierContactType,
  CarrierWithContactsByType,
} from "../types/carrier";

export const getCarrierWithContactsByType = (
  carrier: Pick<RfpCarrierResponse, "carrierId" | "name" | "contacts"> &
    Partial<Pick<RfpCarrierResponse, "shareIdentifier">>,
): CarrierWithContactsByType => ({
  carrierId: carrier.carrierId ?? null,
  carrierName: carrier.name,
  shareIdentifier: carrier.shareIdentifier ?? null,
  contactsByType: carrier.contacts.reduce<Record<CarrierContactType, string[]>>(
    (acc, contact) => {
      const contactsByType = acc[contact.type];
      if (contactsByType) {
        contactsByType.push(contact.email);
      } else {
        logger.error(
          `Unknown contact type "${contact.type}" for carrier "${carrier.name}"`,
        );
      }
      return acc;
    },
    { sales_rep: [], general: [], support: [] },
  ),
});

export const toCarriersWithContactsByType = ({
  connected,
  unconnected,
  unknown,
}: RfpCarriersResponse): CarrierWithContactsByType[] =>
  [...(connected ?? []), ...(unconnected ?? []), ...(unknown ?? [])].map(
    getCarrierWithContactsByType,
  );

export const getCarriersWithContactsByType = (
  carriers: RfpCarrierResponse[] | null,
): { missingSalesRep: boolean; carriers: CarrierWithContactsByType[] } => {
  const carrierContactsByType =
    carriers?.map(getCarrierWithContactsByType) ?? [];
  const missingSalesRep = carrierContactsByType.some(
    (carrier) => carrier.contactsByType.sales_rep.length === 0,
  );

  return {
    missingSalesRep,
    carriers: carrierContactsByType,
  };
};
